import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Lock, User, ArrowLeft } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/admin/login`, { username, password });
      toast.success("Bienvenido!");
      navigate("/admin");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Credenciales incorrectas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4" data-testid="login-page">
      <div className="w-full max-w-md">
        <Link
          to="/"
          className="flex items-center gap-2 text-[#A0A0A0] mb-8 hover:text-[#00FF66] transition-colors"
          data-testid="back-to-store-link"
        >
          <ArrowLeft className="w-5 h-5" />
          Volver a la tienda
        </Link>

        <div className="glass-card p-8">
          <div className="text-center mb-8">
            <h1 className="font-oswald text-3xl mb-2">
              <span className="text-[#00FF66]">O</span>
              <span className="text-white">Y</span>
              <span className="text-[#B026FF]">B</span>
            </h1>
            <p className="text-[#A0A0A0] text-sm">Panel de Administracion</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-6">
            <div className="space-y-2">
              <label htmlFor="username" className="block text-sm font-medium text-[#A0A0A0]">Usuario</label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#A0A0A0]/50" />
                <input
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full bg-[#050505] border border-white/10 text-white pl-10 pr-3 py-3 rounded-xl focus:border-[#00FF66] focus:outline-none transition-colors"
                  placeholder="Tu usuario"
                  required
                  data-testid="username-input"
                />
              </div>
            </div>

            <div className="space-y-2">
              <label htmlFor="password" className="block text-sm font-medium text-[#A0A0A0]">Contrasena</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#A0A0A0]/50" />
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full bg-[#050505] border border-white/10 text-white pl-10 pr-3 py-3 rounded-xl focus:border-[#00FF66] focus:outline-none transition-colors"
                  placeholder="Tu contrasena"
                  required
                  data-testid="password-input"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#00FF66] text-[#050505] py-3 font-bold rounded-full hover:shadow-[0_0_20px_rgba(0,255,102,0.4)] transition-all duration-300 disabled:opacity-50"
              data-testid="login-submit-btn"
            >
              {loading ? "Entrando..." : "Entrar"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
